<template>
  <div :class="isUploaded ? 'inputContainer folded' : 'inputContainer'">
    <div class="inputUi">
      <div v-if="!isUploaded">
        <font-awesome-icon class="upload" icon="fa-file-arrow-up" />
        <p>
          {{ $t('PEER.FileUploader.filePlaceholder1') }} <br />
          {{ $t('PEER.FileUploader.filePlaceholder2') }}
        </p>
      </div>
      <div v-else class="uploadedFile">
        <font-awesome-icon icon="fa-file" /> {{ paperOriginData.name }}
      </div>
    </div>
    <div
      :class="isDraged ? 'dragWindow draged' : 'dragWindow'"
      @dragenter="onDragEnter"
      @dragleave="onDragLeave"
      @dragover="onDragOver"
      @drop="onDrop"
      @click="onClick"
    ></div>
    <input type="file" ref="fileUploader" accept=".csv, .xlsx" @change="uploadFileByClick" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'FileUploader',
  props: {
    isUploaded: { type: Boolean, default: false },
  },
  data() {
    return {
      isDraged: false,
    };
  },
  methods: {
    ...mapActions('peerPaper', ['AC_SET_PAPER_ORIGIN_DATA', 'AC_INIT_PAPER']),
    readFileAsync(file) {
      const FILE_NAME = file.name;
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let tmpResult = [];

        reader.onload = (event) => {
          let data = event.target.result;
          data = new Uint8Array(data);

          let excelFile = XLSX.read(data, { type: 'array' });

          excelFile.SheetNames.forEach((sheetName) => {
            const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1 });
            if (roa.length) tmpResult.push({ sheet: sheetName, data: roa });
          });

          resolve({ name: FILE_NAME, data: tmpResult });
        };

        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },

    async handleUploadFile(file) {
      try {
        if (this.paperOriginData) {
          this.AC_INIT_PAPER();
        }
        const content = await this.readFileAsync(file);
        this.$emit('toggleUpload', false);

        this.AC_SET_PAPER_ORIGIN_DATA(content).then(() => {
          this.$emit('toggleUpload', true);
        });
      } catch (error) {
        console.log(error);
      }
    },
    onClick() {
      this.$refs.fileUploader.click();
    },
    onDragEnter() {
      this.isDraged = true;
    },
    onDragLeave() {
      this.isDraged = false;
    },
    onDragOver(event) {
      event.preventDefault();
    },
    onDrop(event) {
      event.preventDefault(event);
      const file = event.dataTransfer.files[0];
      this.handleUploadFile(file);
      this.isDraged = false;
    },

    uploadFileByClick(event) {
      const file = event.target.files[0];
      this.handleUploadFile(file);
    },
  },
  computed: {
    ...mapState('peerPaper', {
      paperOriginData: (state) => state.paperOriginData,
    }),
    ...mapGetters('peerPaper', ['GE_MOVE_NEXT_STATE']),
  },
};
</script>

<style lang="scss" scoped>
.inputContainer {
  position: relative;
  display: flex;
  align-items: center;
  height: 200px;
  background: rgb(230, 230, 230);
  margin: 20px auto;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgb(171, 171, 171);
  font-size: 1rem;

  & :hover {
    cursor: pointer;
  }
  & input {
    display: none;
  }

  .inputUi {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    border: 2px dashed rgb(180, 180, 180);
    border-radius: 10px;
    margin: auto;
    text-align: center;
    color: rgb(180, 180, 180);

    .upload {
      margin-bottom: 20px;
      font-size: 36px;
    }
    p {
      margin: 0;
    }
  }

  .dragWindow {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
  .uploadedFile {
    text-align: left;
    padding-left: 20px;
    color: black;
  }
}
.folded {
  height: 60px;
}
.draged {
  background: rgba(255, 255, 255, 0.444);
}
</style>
